import React from 'react';
import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const ModalDialog = ({ open, handleClose, Header, className, content, style, icon, maxwidth }) => open != '' ? (
    <Dialog open={open} onClose={handleClose} aria-labelledby="modal-dialog" fullWidth={true} maxWidth={maxwidth ? maxwidth : 'sm'}>
        <DialogTitle id="modal-dialog" onClose={handleClose} className={className} style={style}>
            {icon}
            <h2>{Header.Title}</h2>
            <p>{Header.Sub_Title}</p>
            <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent dividers>
            {content}
        </DialogContent>
    </Dialog>

) : null;

export default ModalDialog;